import React, { useContext, useState } from "react";

const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [userid, setUserid] = useState(null);
  const [pgid, setPgid] = useState(null);
  const [rcount, setRcount] = useState(null);
  const [roomid, setRoomid] = useState(null);
  const [bcount, setBcount] = useState(null);
  const [guestid, setGuestid] = useState(null);

  const login = (username) => {
    setUser(username);
  };

  const logout = () => {
    setUser(null);
  };

  const userId = (id) => {
    setUserid(id);
    // console.log(userid);
  };

  const pgId = (id) => {
    setPgid(id);
  };

  const Rcount = (count) => {
    setRcount(count);
  };

  const roomId = (id) => {
    setRoomid(id);
  };

  const Bcount = (count) => {
    setBcount(count);
  };

  const guestId = (id) => {
    setGuestid(id);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        login,
        logout,
        userId,
        pgId,
        roomId,
        userid,
        pgid,
        roomid,
        Rcount,
        rcount,
        Bcount,
        bcount,
        guestId,
        guestid,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  return useContext(AuthContext);
};
